import type { IconProps } from "./types";

export function CircleAlertBold({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 14.0996C9.50294 14.0996 9.09961 14.5029 9.09961 15C9.09961 15.4971 9.50294 15.9004 10 15.9004H10.0098C10.5068 15.9004 10.9102 15.4971 10.9102 15C10.9102 14.5029 10.5068 14.0996 10.0098 14.0996H10ZM10 4.59961C9.50294 4.59961 9.09961 5.00294 9.09961 5.5V11.5C9.09961 11.9971 9.50294 12.4004 10 12.4004C10.4971 12.4004 10.9004 11.9971 10.9004 11.5V5.5C10.9004 5.00294 10.4971 4.59961 10 4.59961Z"
        fill={currentColor}
        transform="translate(2 2)"
      />
    </svg>
  );
}
